export const POLYGON_LAYER_STYLE = {
  strokeColor: 'black',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  fillColor: 'black',
  fillOpacity: 0.4,
};

export const EGRESS_ACTIVE = 3;
